import { render, staticRenderFns } from "./IntegrationsList.vue?vue&type=template&id=e679af84&"
import script from "./IntegrationsList.vue?vue&type=script&lang=js&"
export * from "./IntegrationsList.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports